import PropTypes from 'prop-types';
import styles from './Divider.module.css';

/**
 * Divider - Horizontal divider with optional label
 * Used to visually separate content sections
 */
export function Divider({
  label,
  color = 'default',
  spacing = 'md',
  className = '',
  ...props
}) {
  const classNames = [
    styles.divider,
    styles[color],
    styles[`spacing-${spacing}`],
    label && styles.withLabel,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (label) {
    return (
      <div className={classNames} {...props}>
        <span className={styles.line} />
        <span className={styles.label}>{label}</span>
        <span className={styles.line} />
      </div>
    );
  }

  return <hr className={classNames} {...props} />;
}

Divider.propTypes = {
  label: PropTypes.string,
  color: PropTypes.oneOf(['default', 'muted', 'cyan', 'lime']),
  spacing: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default Divider;
